import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AuthState, SignUpFormState } from "./types";

import { RootState } from "lib/store";

const initialState: AuthState = {
  signUpForm: {
    email: "",
    password: "",
    first_name: "",
    last_name: "",
    region_id: 3,
    role_id: 3,
    avatar: "",

    influencer_type: "1",
    companyName: "",
    job_type: "",
    about_me: "",

    business: "",
    phone: "",
    address1: " ",
    zipcode: "",
    city: "",
    state: "",
    address2: "",
    description: "",
    industry_id: 1,
    industry_category: "",
    image: "",
    business_headline: "",
    business_type_id: [],
    industry_ids: [],
    category_ids: [],
    customer_type_ids: [],
    categories_ids: [],
  },
  activeStep: 0,
  forgotPasswordEmail: undefined,
  forgotPasswordOtp: undefined,
};

// Slice
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSignUpFormState(
      state: AuthState,
      action: PayloadAction<SignUpFormState>
    ) {
      state.signUpForm = action.payload;
    },
    setActiveStep(state: AuthState, action: PayloadAction<number>) {
      state.activeStep = action.payload;
    },
    resetAuthState() {
      return initialState;
    },
    setForgotPasswordEmail(
      state: AuthState,
      action: PayloadAction<string | undefined>
    ) {
      state.forgotPasswordEmail = action.payload;
    },
    setForgotPasswordOtp(
      state: AuthState,
      action: PayloadAction<string | undefined>
    ) {
      state.forgotPasswordOtp = action.payload;
    },
  },
});

const selectSlice = (state: RootState) => state.authSlice || initialState;

export const selectSignUpForm = createSelector(
  [selectSlice],
  (state: AuthState) => state.signUpForm
);

export const selectActiveStep = createSelector(
  [selectSlice],
  (state: AuthState) => state.activeStep
);

export const selectForgotPasswordEmail = createSelector(
  [selectSlice],
  (state: AuthState) => state.forgotPasswordEmail
);

export const selectForgotPasswordOtp = createSelector(
  [selectSlice],
  (state: AuthState) => state.forgotPasswordOtp
);

export const {
  setSignUpFormState,
  setActiveStep,
  resetAuthState,
  setForgotPasswordEmail,
  setForgotPasswordOtp,
} = authSlice.actions;

export default authSlice.reducer;
